import React, { Component } from 'react';
import { arrayOf, shape, string, number, func, bool } from 'prop-types';
import cx from 'classnames';
import styles from './styles.scss';

export default class DaypartTableRow extends Component {
  static propTypes = {
    data: arrayOf(shape({
      time: string,
      adVisit: number,
      ads: number,
      visitsPerAd: number,
      visit: number,
      avgAdCost: number,
      newAdUsers: number,
      newAdUsersPerAds: number,
    })),
    campaignAvgAdCost: number,
    onCellClick: func,
    isCustomReport: bool,
    isShowNewAdUsers: bool
  }

  static defaultProps = {
    data: []
  }

  render() {
    const { data, onCellClick, campaignAvgAdCost, isCustomReport, isShowNewAdUsers } = this.props;
    const { time, adVisit, ads, visit, visitsPerAd, avgAdCost, newAdUsers, newAdUsersPerAds } = data;
    const formattedAdVisit = parseFloat(adVisit.toFixed(1));
    const formattedAvgAdCost = avgAdCost == null ? 'N/A' : `$${avgAdCost.toFixed(2).toLocaleString()}`;
    const tableCellClasses = isCustomReport ? cx(styles.tableCell, styles.customTableCell) : styles.tableCell;

    return(
      <div data-test="daypartTableRow" className={styles.tableRow}>
        <div data-test="daypartTableName" className={tableCellClasses}>{time.toLocaleString()}</div>
        <div
          className={tableCellClasses}
          onClick={onCellClick({data, key: 'visit'})}
          data-test="daypartTableVisits"
        >
          {visit.toLocaleString()}
        </div>
        {
          isShowNewAdUsers ?
          <div
            className={tableCellClasses}
            onClick={onCellClick({data, key: 'newAdUsers'})}
          >
            {newAdUsers.toLocaleString()}
          </div> :
          <div
            data-test="daypartTableAdVisits"
            className={tableCellClasses}
            onClick={onCellClick({data, key: 'adVisit'})}
          >
            {formattedAdVisit.toLocaleString()}
          </div>
        }
        <div
          data-test="daypartTableAds"
          className={tableCellClasses}
          onClick={onCellClick({data, key: 'ads'})}
        >
          {ads.toLocaleString()}
        </div>
        {
          isShowNewAdUsers ?
          <div
            className={tableCellClasses}
            onClick={onCellClick({data, key: 'newAdUsersPerAds'})}
          >
            {newAdUsersPerAds.toLocaleString()}
          </div> :
          <div
            data-test="daypartTableAdvisitsAds"
            className={tableCellClasses}
            onClick={onCellClick({data, key: 'visitsPerAd'})}
          >
            {visitsPerAd.toLocaleString()}
          </div>
        }
        {
          campaignAvgAdCost != null &&
          <div
            data-test="daypartTableAvgAdCost"
            className={tableCellClasses}
            onClick={onCellClick({data, key: 'avgAdCost'})}
          >
            {formattedAvgAdCost}
          </div>
        }
      </div>
    )
  }
};
